import styled from "styled-components";
import { theme } from '../../../theme'
import { FaBullhorn } from "react-icons/fa";
import { Button } from '../../button'
import { Link } from "react-router-dom";

const Item = styled.div`
  display: flex;
//   justify-content: space-around;
  align-items: center;
    padding: 1.5rem 1.9rem;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`


const TextContainer = styled.div`
    margin: 0 auto 0 1.9rem;

    .main-header {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
`


const AccountActionItem = ({ title }) => {
    const isTeacher = window.location.pathname.includes('teacher')
    return (
        <Item>
            <ImageContainer>
                <FaBullhorn />
            </ImageContainer>
            <TextContainer>
                <p className="main-header">{title}</p>
            </TextContainer>
            {isTeacher ? (
                <Link to={
                    title == "Account" ? "/teacher/account/edit"
                        :
                        title == "Profile & Privacy" ? "/teacher/account/profile-privacy"
                            :
                            title == "Notifications" ? "/teacher/account/notifications"
                                :
                                title == "Change Password" ? "/teacher/account/change-password" : "/teacher/account"
                }>
                    <Button style={{ width: '5.5rem', height: '2.5rem', fontSize: '1rem' }} variant="secondary">edit</Button>
                </Link>
            ) :
                (
                    <Link to={
                        title == "Account" ? "/account/edit"
                            :
                            title == "Profile & Privacy" ? "/account/profile-privacy"
                                :
                                title == "Notifications" ? "/account/notifications"
                                    :
                                    title == "Change Password" ? "/account/change-password" : "/account"
                    }>
                        <Button style={{ width: '5.5rem', height: '2.5rem', fontSize: '1rem' }} variant="secondary">edit</Button>
                    </Link>
                )
            }

        </Item>
    )
}

export default AccountActionItem
